import getCustomAxios from "../Helpers/customAxios";
import { camelizeKeys, decamelizeKeys } from "humps";
import {
  RHEA_CMS_USERS_API_ENDPOINT,
  RHEA_CMS_USER_API_ENDPOINT,
  RHEA_CMS_USER_CHANGE_PASSWORD_API_ENDPOINT,
} from "../Constants/API";
import { DateTime } from "luxon";

export function getUserListAPI(
  filtersMap = new Map(),
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // The following code will generate the query parameters for the url based on the map.
  let aURL = RHEA_CMS_USERS_API_ENDPOINT;
  filtersMap.forEach((value, key) => {
    if (aURL.indexOf("?") > -1) {
      aURL += "&" + key + "=" + value;
    } else {
      aURL += "?" + key + "=" + value;
    }
  });

  axios
    .get(aURL)
    .then((successResponse) => {
      const responseData = successResponse.data.items;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function postUserCreateAPI(
  data,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // Minor formatting to support API.
  data.no = parseInt(data.no);
  data.duration = parseInt(data.duration);
  data.created = parseInt(data.created);
  data.targetHeartRateRatio = parseFloat(data.targetHeartRateRatio);

  // To Snake-case for API from camel-case in React.
  let decamelizedData = decamelizeKeys(data);

  axios
    .post(RHEA_CMS_USERS_API_ENDPOINT, decamelizedData)
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function getUserDetailAPI(
  sessionID,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .get(RHEA_CMS_USER_API_ENDPOINT.replace("{id}", sessionID))
    .then((successResponse) => {
      const responseData = successResponse.data.data;
      console.log(successResponse);
      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      const birthday = DateTime.fromSeconds(data.birthday);
      const birthdayISO = birthday.toISO();

      console.log("orig birthday:", data.birthday);
      console.log("modi birthday:", birthday);
      console.log("modi birthday:", birthdayISO);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function putUserUpdateAPI(
  decamelizedData,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .put(
      RHEA_CMS_USER_API_ENDPOINT.replace("{id}", decamelizedData.id),
      decamelizedData
    )
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function deleteUserAPI(
  id,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .delete(RHEA_CMS_USER_API_ENDPOINT.replace("{id}", id))
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function putUserChangePasswordOperationAPI(
  userID,
  newPassword,
  newPasswordRepeated,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  var decamelizedData = {
    password: newPassword,
    password_repeated: newPasswordRepeated,
  };
  axios
    .put(
      RHEA_CMS_USER_CHANGE_PASSWORD_API_ENDPOINT.replace("{id}", userID),
      decamelizedData
    )
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}
